import { render, staticRenderFns } from "./FacetRangeChart.vue?vue&type=template&id=027caaf8&scoped=true&"
import script from "./FacetRangeChart.vue?vue&type=script&lang=js&"
export * from "./FacetRangeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027caaf8",
  null
  
)

export default component.exports